import { Field, FieldProps } from 'formik';
import React from 'react';

import { Select } from '../../../../../../ui';
import cityOptions from './cities.json';

const Component = ({ field, form }: FieldProps) => {
    return (
        <Select
            label="Location"
            name={field.name}
            id="locationField"
            value={cityOptions.find((city) => city.value === field.value)}
            placeholder="Start typing your city"
            options={cityOptions}
            isSearchable={true}
            search
            onChange={(option) => {
                if (option) {
                    form.setFieldValue(field.name, option.value);
                }
            }}
        />
    );
};

export function LocationField() {
    return <Field name="location" component={Component} />;
}
